import {Injectable} from '@angular/core';
import { MatSnackBar as MatSnackBar, MatSnackBarConfig as MatSnackBarConfig } from '@angular/material/snack-bar';
import {BreakpointObserver} from '@angular/cdk/layout';
import {map} from 'rxjs/operators';

@Injectable()
export class NotifyService {

  private default: MatSnackBarConfig = {};

  constructor(private snackbar: MatSnackBar, private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver
      .observe('(max-width: 600px)')
      .pipe(map(r => r.matches))
      .subscribe(result => {
        if (!result) {
          this.default = {
            verticalPosition: 'top',
            horizontalPosition: 'end',
            duration: 3000
          };
        } else {
          this.default = {
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            duration: 3000
          };
        }
      });
  }

  public success(message: string) {
      this.snackbar.open(message, 'x', this.config({panelClass: ['success-snackbar']}));
  }

  public error(message: string) {
    this.snackbar.open(message, 'x', this.config({panelClass: ['error-snackbar']}));
  }

  private config(config?: MatSnackBarConfig) {
    return { ...this.default, ...config };
  }
}

